import {
  BUSINESS_TX_STATE_UPDATE_FAILURE,
  BUSINESS_TX_STATE_UPDATE_REQUEST,
  BUSINESS_TX_STATE_UPDATE_SUCCESS,
} from '../actions/business_update_tx_state'

export const businessUpdateTxState = (
  state = {
    isFetching: false,
    responseData: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case BUSINESS_TX_STATE_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case BUSINESS_TX_STATE_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        responseData: action.response,
        errorMessage: null,
      }
    case BUSINESS_TX_STATE_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
